<template>
  <div>
    <div id="rates" class="d-flex flex-column justify-content-top align-items-left" v-if="ratesLg">
      <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
        <row
          class="rowa"
          v-for="(rates, index) in ratesLg.rates"
          :isBreakfast="index > Object.keys(ratesLg.rates).length - 2"
          :key="index"
          :ratesLg1="rates"
        ></row>
      </div>
    </div>
  </div>
</template>

<script>
import Row from "./rowRates";
import LegalNoticeLeft from "./legalNoticeLeft";

export default {
  components: {
    row: Row,
    legalNoticeLeft: LegalNoticeLeft,
  },
  name: "TribeRatesHorizontalV1Rates",
  props: {
    ratesLg: Object,
  },
};
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_tribe.scss";

#rates {
  width: 100%;
  height: 100%;

  #rows {
    width: 100%;
    height: 100%;

    .rowa:nth-of-type(n + 8) {
      display: none !important;
    }

    .rowa:nth-of-type(n + 6) {
    }
  }
}
</style>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_tribe.scss";
</style>



// WEBPACK FOOTER //
// src/components/tribe/rates/horizontal/v1/rates/rates.vue